import React, { Component } from "react";
import { ENABLE_STRIPE } from "../../config/featureFlags";
import { connect } from "react-redux";
import { Game, GState, IndexedGames } from "../../types/game";
import { Views } from "../Dashboard";
import { GlobalState } from "../../types/globalState";
import { User, UserBrifObj } from "../../types/user";
import { hideAuxiliaryDialog, showAuxiliaryDialog } from "../SharedComponents/AuxiliaryDialog";
import { showAlertDialog } from "../SharedComponents/AlertDialog";
import { switchComponent } from "../../actions/componentRouter";
import GameActions from "../../actions/games";
import GamePlayersManager from "./GamePlayersManager";
import GameAdditionalOrganisersManager from "./GameAdditionalOrganisersManager";
import IndividualLeaderBoard from "../leaderBoard/IndividualLeaderBoard";
import QuickScorePlayersList from "../QuickScore/QuickScorePlayersList";
import Moment from "moment";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import withStyles from "@material-ui/core/styles/withStyles";
import { WithStyles, createStyles, Theme, IconButton, Button, ListItemSecondaryAction, Chip, Box } from "@material-ui/core";
import {
  Assignment,
  ExitToApp,
  PersonAdd,
  PlayCircleFilled,
  SupervisorAccount,
  Share,
  Link,
  PictureAsPdf,
  Email,
  Edit,
  Gavel,
  AccountBalanceWallet,
  CheckCircle,
  PriorityHigh,
  Assessment,
  History,
} from "@material-ui/icons";
import CropFreeIcon from "@material-ui/icons/CropFree";
import PenIcon from "@material-ui/icons/BorderColor";
import { hideDialog, showDialog } from "../SharedComponents/Dialog";
import { showSnackbar } from "../SharedComponents/Notifier";
import LeaveGameReasonDialog from "./LeaveGameReasonDialog";
import GameLeaveHistory from "./GameLeaveHistory";
import { LeaveGamePayload } from "../../types/gameLeave";
import { AxiosError } from "axios";
import { ErrorOnlyCallback } from "../../types/actions";
import Loading from "../Loading";
import { share } from "../../utils/share";
import Messages from "../../consts/Messages";
import SubmissionCardConfirmtionDialog from "./SubmissionCardConfirmtionDialog";
import EmailDialog, { showEmailDialog } from "../SharedComponents/EmailDialog";
import LinkedGamesList from "./LinkedGamesList";
import { isCombinedGame } from "./../../utils/index";
import { StartSheet } from "./GameStartSheet";
import { Player, PayStatus } from "../../types/player";
import { Rules } from "types/user";
import GameDialogHeader from "./GameDialogHeader";
import GameMenuPlayerHeader from "./GameMenuPlayerHeader";
import { showPickerDialog } from "../SharedComponents/PickerDialog";
import { hcpConvertor } from "../../utils/hcpConvertor";
import { buildFileSelector } from "../../utils/fileSelector";
import UserAction from "../../actions/user";
import { userCanManageGamePayments, userCanViewReceivedPayments } from "../../utils/gamePaymentAuth";
import { shouldUsePayBeforeJoinCheckout } from "../../utils/payBeforePlay";
import { openPayBeforeJoinPayment } from "../../utils/payBeforeJoinFlow";
import { getPaymentDialogSubtitle, getPaymentDialogTitle } from "../../utils/paymentDialogMeta";
import _ from "lodash";
import GamePayment from "../Payment/GamePayment";
import GamePaymentSummary from "./GamePaymentSummary";
import GuestPlayersTable from "./GuestPlayers";
import RHIDisplay from "../Profile/RHIDisplay";
import { isRangeGame } from "../../utils/rhiGame";
import GameSetup from "./GameSetup";
import config from "config";
import { EmailTypes } from "types/general";
import QRCode from "components/QRCode";
import EmailOptionsDialog from "components/SharedComponents/EmailOptions";
import VideoPopup from "components/SharedComponents/VideoPopup";
import { HELP_VIDEOS } from "consts";
import Config from "config";
import { MOBILE_BREAKPOINT } from "../../consts/dialog";

const photoSelector = buildFileSelector(false, ".jpg,.png,.jpeg");

interface Props extends WithStyles {
  getGameById(
    id: string,
    queryType?: string,
    updateRedux?: boolean,
    callback?: (err: AxiosError | null, data: Game) => void,
  ): void;
  recalculatePlayingHcp(id: string, playerId: string, hci: number, callback?: (err?: any) => void): void;
  updateMe(userInfo: any, callback?: any): void;
  updateHcp(id: string, hci: number, callback?: any): void;
  switchComponent(view: any, props?: any): void;
  activateGame(id: string): void;
  joinGame(id: string, callback?: (error: AxiosError | null, data: Game[]) => void): void;
  leaveGame(id: string, payload: LeaveGamePayload, callback?: ErrorOnlyCallback): void;
  games: IndexedGames;
  gameId: string;
  user: User;
}

interface State {
  openQuickscoriePlayersListDialog: boolean;
  isGameFull: boolean;
  emailOpen: boolean;
  paymentSummaryRefreshKey: number;
}

class GameNavigationDialog extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      openQuickscoriePlayersListDialog: false,
      isGameFull: false,
      emailOpen: false,
      paymentSummaryRefreshKey: 0,
    };
    this.props.getGameById(props.gameId, undefined, true);
  }

  onLeaveGame(gameId: string) {
    showDialog(
      <LeaveGameReasonDialog
        onConfirm={(payload: LeaveGamePayload, callback) => {
          this.props.leaveGame(gameId, payload, error => callback(error || undefined));
        }}
      />,
      "sm",
      false,
      false,
      true,
      "Leave game",
    );
  }

  onOpenLarboard = (gameId: string, widescreen?: boolean) => {
    const game = this.getGame();
    const useWidescreen = Boolean(widescreen);

    showAuxiliaryDialog(
      <IndividualLeaderBoard gameId={gameId} games={this.props.games} />,
      "xl",
      true,
      true,
      true,
      "",
      useWidescreen,
    );
  };

  onEnterGame(gameId: string) {
    const userId = this.props.user!._id;
    const game = this.getGame();
    const me = game?.players?.[userId];
    if (me) {
      const group = me.group;
      if (group) {
        this.props.switchComponent(Views.GameManager, { gameId, group });
        hideDialog();
      } else {
        this.props.switchComponent(Views.GroupSelector, { gameId });
        hideDialog();
      }
    }
  }

  imPlaying(game: Game) {
    return !!game?.players?.[this.props.user._id];
  }

  myPlayerObject(game: Game) {
    return game?.players?.[this.props.user._id];
  }

  onEditHi = () => {
    const game = this.getGame();
    if (!game) return;
    const { user } = this.props;
    const imPlaying = this.imPlaying(game);
    const player = this.myPlayerObject(game);
    if (imPlaying && player && player.state === "done") return;

    showPickerDialog(
      "Handicap Index",
      "number",
      (hcp: string) => {
        const hci = parseFloat(hcpConvertor(hcp));
        if (imPlaying) {
          this.props.recalculatePlayingHcp(game._id, user._id, hci, err => {
            if (!err) {
              this.props.updateHcp(user._id, hci);
              this.props.getGameById(game._id, undefined, true);
            }
          });
        } else {
          this.props.updateMe({ hcp: hci });
        }
      },
      undefined,
      null,
      null,
      false,
      true,
    );
  };

  onChangePhoto = () => {
    photoSelector.onchange = (event: any) => {
      const file = event.target.files && event.target.files[0];
      photoSelector.value = "";
      if (file) this.props.updateMe({ image: file });
    };
    photoSelector.click();
  };

  getGame = () => {
    return this.props.games[this.props.gameId];
  };

  onOpenRhiCalculationTable = () => {
    const { user } = this.props;
    if (!user?._id) return;
    showAuxiliaryDialog(
      <RHIDisplay playerId={user._id} inDialog currentUserRule={user.rule} />,
      "lg",
      true,
      true,
      true,
      "RHI Calculation Table",
    );
  };

  sendNotifierMail = () => {
    const game = this.getGame();

    showAuxiliaryDialog(
      <SubmissionCardConfirmtionDialog
        gameId={game._id}
        homeClub={this.props.user.homeClub}
        gameClub={game.course.club}
      />,
      "xl",
      true,
    );
  };

  handlePGComponentSwitch = () => {
    const game = this.getGame();
    if (!game) return;
    hideAuxiliaryDialog();
    const imOrganiser = game.organizers.find(o => o._id === this.props.user._id) !== undefined;

    showAuxiliaryDialog(
      <StartSheet
        gameId={game._id}
        games={this.props.games}
        downloadable={imOrganiser}
        onSwitchClick={this.handleSSComponentSwitch}
      />,
      "xl",
      true,
      true,
      true,
      `${game.name} Start Sheet`,
    );
  };

  handleSSComponentSwitch = () => {
    const game = this.getGame();
    if (!game) return;
    hideAuxiliaryDialog();

    showAuxiliaryDialog(
      <GamePlayersManager
        onSwitchClick={this.handlePGComponentSwitch}
        gameId={game._id}
        initialGame={game}
        minChar={3}
      />,
      "lg",
      true,
      true,
      true,
      "Players & Groups",
      false,
      game.name,
    );
  };

  onOpenScorerSetup = () => {
    const userId = this.props.user._id;
    const game = this.getGame();
    this.props.switchComponent(Views.ScorerGameSetup, {
      gameId: game._id,
      group: game?.players?.[userId]?.group,
    });
    hideDialog();
  };

  showEmailNotify = () => {
    const game = this.getGame();
    const organizer = game.organizers[0];
    showEmailDialog(`Game Code ${game.code}`, `${organizer.name} ${organizer.lastName}`, organizer._id);
  };

  onJoinGame = (gameId: string) => {
    const { isGameFull } = this.state;
    if (isGameFull) return;
    const game = this.getGame();
    if (game && shouldUsePayBeforeJoinCheckout(game, userCanManageGamePayments(game, this.props.user))) {
      openPayBeforeJoinPayment(game, () => {
        this.props.getGameById(gameId, undefined, true);
        hideDialog();
      });
      return;
    }
    this.props.joinGame(gameId, error => {
      if (error) {
        const apiError = error?.response?.data?.error;
        if (apiError) {
          showSnackbar(apiError, 7000, "warning");
        }
        if (error?.response?.data.payload?.isFull) {
          this.setState({ isGameFull: true });
          showAlertDialog(
            "Ooops !",
            "The game is full, Do you want to send an Email to the game Organiser?",
            () => this.showEmailNotify(),
            () => {},
          );
        }
      } else hideDialog();
    });
  };

  isGameFinished = () => {
    const game = this.getGame();
    const { user } = this.props;
    if (!this.imPlaying(game)) return false;
    const me = game.players?.[user._id];
    if (me?.group) return this.areAllCardsSubmited(this.getTeammates(me.group.name));
  };

  getTeammates = (teamName: String) => {
    const game = this.getGame();
    return Object.values(game.players || {}).filter(player => player.group?.name === teamName);
  };

  bumpPaymentSummary = () => {
    this.setState(s => ({ paymentSummaryRefreshKey: s.paymentSummaryRefreshKey + 1 }));
  };

  onOpenReceivedPayments = (game: Game) => {
    if (!game._id) return;
    showAuxiliaryDialog(
      <GamePaymentSummary
        gameId={game._id}
        refreshKey={this.state.paymentSummaryRefreshKey}
        alwaysExpanded
      />,
      "md",
      true,
      true,
      true,
      "Received payments",
    );
  };

  openGamePayment = (game: Game, type: "guest" | "pay" | "paid") => {
    const title = type === "guest" ? "Guests" : getPaymentDialogTitle(game);
    const subtitle = type === "guest" ? game.name : getPaymentDialogSubtitle(game);
    showAuxiliaryDialog(
      <GamePayment
        type={type}
        game={game}
        payBeforeJoin={false}
        onPaymentComplete={() => {
          this.bumpPaymentSummary();
          if (game._id) {
            this.props.getGameById(game._id, undefined, true);
          }
        }}
      />,
      "xl",
      true,
      true,
      true,
      title,
      false,
      subtitle,
    );
  };

  onGuestClick = (game: Game) => {
    this.openGamePayment(game, "guest");
  };

  areAllCardsSubmited = (players: Player[]) => players.every(player => player.state === "done");

  filterGuestPlayers = (currentUser: User, guests: Player[], organizers: UserBrifObj[], player: Player) => {
    // Organiser has access to all guests
    if (currentUser.rule === Rules.Organiser) {
      const org = organizers.find(o => o._id === currentUser._id);
      if (org) return guests;
    }

    if (!player?.group?.name) return [];

    const userGroup = player.group.name;
    return guests.filter(p => p.group?.name === userGroup);
  };

  render() {
    const { user, classes } = this.props;
    const game = this.getGame();
    if (!game) return null;
    const imPlaying = this.imPlaying(game);
    const player = this.myPlayerObject(game);
    const guestPlayers = this.filterGuestPlayers(
      user,
      Object.values(game.players || {}).filter(p => p.guest),
      game.organizers,
      player,
    );
    const { isGameFull } = this.state;
    const isCombined = isCombinedGame(game.competition);
    const imOrganiser = game.organizers!.filter((o: UserBrifObj) => o._id === user._id).length > 0;
    const isAdmin = user.rule === Rules.Admin;
    const shouldPayBeforePlay = game.paymentRules?.payBeforePlay && player?.payStatus === PayStatus.NOT_PAID;
    const canManagePayments = userCanManageGamePayments(game, user);
    const canViewReceivedPayments = userCanViewReceivedPayments(game, user);
    const payBeforePlay = !!game.paymentRules?.payBeforePlay;
    const showPayMenu = game.isPaid && (canManagePayments || !payBeforePlay || imPlaying);
    const isSelfPayPlayer = imPlaying && !canManagePayments;
    const myPayStatus = player ? Number(player.payStatus) : PayStatus.NOT_PAID;
    const myPaymentPaid = isSelfPayPlayer && myPayStatus === PayStatus.PAID;
    const myPaymentGuest = isSelfPayPlayer && myPayStatus === PayStatus.GUEST;
    const rosterPlayers = Object.values(game.players || {});
    const unpaidRosterCount = rosterPlayers.filter(p => Number(p.payStatus) === PayStatus.NOT_PAID).length;
    const allRosterSettled =
      canManagePayments && rosterPlayers.length > 0 && unpaidRosterCount === 0;
    const showAllSettledChip = allRosterSettled && !game.isPaid;

    return (
      <div className={classes.menuRoot}>
        <Loading />
        <List disablePadding className={classes.menuList}>
          <GameMenuPlayerHeader
            user={user}
            player={player}
            imPlaying={imPlaying}
            isRange={isRangeGame(game)}
            competitionId={game.competition._id}
            canEditHi={!(imPlaying && player && player.state === "done")}
            onEditHi={this.onEditHi}
            onChangePhoto={this.onChangePhoto}
          />
          <GameDialogHeader
            game={game}
            showPlay={imPlaying && game.state === GState.Playing}
            playDisabled={this.isGameFinished() || shouldPayBeforePlay}
            onPlay={() => this.onEnterGame(game._id)}
          />
          {!isCombined && game.state === GState.Playing && !shouldPayBeforePlay && (
            <ListItem
              button
              className={classes.menuListItemWithAction}
              onClick={() =>
                game._id && showAuxiliaryDialog(<QuickScorePlayersList gameId={game._id} />, "xl", true, true, true)
              }
            >
              <IconButton className={classes.qsLabel}>QS</IconButton>
              <ListItemText className={"fullWidth"}>Quick Score - Quickly enter scores</ListItemText>
              <ListItemSecondaryAction>
                <VideoPopup videoURL={HELP_VIDEOS.GAME_MENU_QUICK} />
              </ListItemSecondaryAction>
            </ListItem>
          )}
          {game.state !== GState.WaitingList && game.isPaid && (
            <>
              {showPayMenu ? (
                <ListItem
                  button
                  onClick={() => this.openGamePayment(game, "pay")}
                  className={[
                    classes.menuListItemWithAction,
                    shouldPayBeforePlay && imPlaying ? classes.paymentRequiredRow : undefined,
                  ]
                    .filter(Boolean)
                    .join(" ")}
                >
                  <IconButton
                    className={
                      shouldPayBeforePlay && imPlaying
                        ? classes.paymentRequiredIcon
                        : classes.qsLabel
                    }
                  >
                    &#163;
                  </IconButton>
                  <ListItemText
                    className={"fullWidth"}
                    primary={
                      <Box display="flex" alignItems="center" flexWrap="wrap" component="span" className={classes.paymentLabelRow}>
                        <span>Payment</span>
                        {showAllSettledChip ? (
                          <Chip
                            label="All settled"
                            size="small"
                            className={`${classes.paymentStatusChipNoIcon} ${classes.paymentAllSettledChip}`}
                          />
                        ) : null}
                        {!showAllSettledChip && shouldPayBeforePlay && imPlaying ? (
                          <Chip
                            label="Required before play"
                            size="small"
                            icon={<PriorityHigh className={classes.paymentRequiredChipIcon} />}
                            className={`${classes.paymentStatusChip} ${classes.paymentRequiredChip}`}
                          />
                        ) : null}
                        {!showAllSettledChip && myPaymentPaid ? (
                          <Chip
                            label="Confirmed"
                            size="small"
                            icon={<CheckCircle className={classes.paymentConfirmedChipIcon} />}
                            className={`${classes.paymentStatusChip} ${classes.paymentConfirmedChip}`}
                          />
                        ) : null}
                        {!showAllSettledChip && myPaymentGuest ? (
                          <Chip
                            label="Guest"
                            size="small"
                            className={`${classes.paymentStatusChipNoIcon} ${classes.paymentGuestChip}`}
                          />
                        ) : null}
                      </Box>
                    }
                  />
                  <ListItemSecondaryAction>
                    <VideoPopup videoURL={HELP_VIDEOS.GAME_MENU_PAYMENT} />
                  </ListItemSecondaryAction>
                </ListItem>
              ) : null}
              {canManagePayments ? (
                <ListItem button className={classes.menuListItemWithAction} onClick={() => this.onGuestClick(game)}>
                  <IconButton className={classes.qsLabel}>G</IconButton>
                  <ListItemText className={"fullWidth"}>Guests</ListItemText>
                  <ListItemSecondaryAction>
                    <VideoPopup videoURL={HELP_VIDEOS.GAME_MENU_PAYMENT_2} />
                  </ListItemSecondaryAction>
                </ListItem>
              ) : null}
              {ENABLE_STRIPE && canViewReceivedPayments && game._id ? (
                <ListItem button onClick={() => this.onOpenReceivedPayments(game)}>
                  <IconButton className={classes.qsLabel}>
                    <AccountBalanceWallet fontSize="small" />
                  </IconButton>
                  <ListItemText className={"fullWidth"} primary="Received payments" />
                </ListItem>
              ) : null}
            </>
          )}
          {game.state !== GState.Done && !shouldPayBeforePlay && (
            <ListItem
              button
              onClick={() =>
                game._id &&
                showAuxiliaryDialog(
                  <StartSheet
                    gameId={game._id}
                    games={this.props.games}
                    downloadable={imOrganiser}
                    onSwitchClick={this.handleSSComponentSwitch}
                  />,
                  "xl",
                  true,
                  true,
                  true,
                  `${game.name} Start Sheet`,
                  game.startSheet?.widescreen,
                )
              }
            >
              <IconButton className={classes.qsLabel}>
                <PictureAsPdf />
              </IconButton>
              <ListItemText className={"fullWidth"}>Start Sheet</ListItemText>
            </ListItem>
          )}
          {game.state !== GState.Done && guestPlayers.length > 0 && !shouldPayBeforePlay && (
            <ListItem
              button
              onClick={() =>
                game._id &&
                showAuxiliaryDialog(
                  <GuestPlayersTable players={guestPlayers} gameId={game._id} />,
                  "xl",
                  true,
                  true,
                  true,
                  "Unregistered players",
                  false,
                  game.name,
                )
              }
            >
              <IconButton className={classes.qsLabel}>
                <PenIcon />
              </IconButton>
              <ListItemText className={"fullWidth"}>Edit unregistered players</ListItemText>
            </ListItem>
          )}
          {(imOrganiser || isAdmin) && (
            <ListItem
              button
              className={classes.menuListItemWithAction}
              onClick={() =>
                game._id &&
                showAuxiliaryDialog(<GameSetup edit={game} onlyPresentationConfig auxiliary />, "sm", true, true, true)
              }
            >
              <IconButton className={classes.qsLabel}>
                <Edit />
              </IconButton>
              <ListItemText className={"fullWidth"}>Edit presentation</ListItemText>
              <ListItemSecondaryAction>
                <VideoPopup videoURL={HELP_VIDEOS.GAME_MENU_PRESENTATION} />
              </ListItemSecondaryAction>
            </ListItem>
          )}
          {(imOrganiser || isAdmin) && (
            <ListItem
              button
              onClick={() =>
                showDialog(
                  <GameLeaveHistory gameId={game._id} />,
                  "sm",
                  false,
                  true,
                  true,
                  "Players who left",
                )
              }
            >
              <IconButton>
                <History color="primary" />
              </IconButton>
              <ListItemText className={"fullWidth"}>Players who left</ListItemText>
            </ListItem>
          )}
          {game.state !== GState.Done && (imOrganiser || isAdmin) && (
            <>
              <ListItem
                button
                className={classes.menuListItemWithAction}
                onClick={() =>
                  showAuxiliaryDialog(
                    <GamePlayersManager
                      onSwitchClick={this.handlePGComponentSwitch}
                      gameId={game._id}
                      initialGame={game}
                      minChar={3}
                    />,
                    "lg",
                    true,
                    true,
                    true,
                    "Players & Groups",
                    false,
                    game.name,
                  )
                }
              >
                <IconButton>
                  <PersonAdd color="primary" />
                </IconButton>
                <ListItemText className={"fullWidth"}>Players & Groups</ListItemText>
                <ListItemSecondaryAction>
                  <VideoPopup videoURL={HELP_VIDEOS.GAME_MENU_PLAYERS} />
                </ListItemSecondaryAction>
              </ListItem>
              <ListItem
                button
                className={classes.menuListItemWithAction}
                onClick={() =>
                  showAuxiliaryDialog(
                    <GameAdditionalOrganisersManager game={game} />,
                    "lg",
                    true,
                    true,
                    true,
                    "Additional organisers",
                    false,
                    game.name,
                  )
                }
              >
                <IconButton>
                  <SupervisorAccount color="primary" />
                </IconButton>
                <ListItemText className={"fullWidth"}>Nominate additonal Organisers</ListItemText>
                <ListItemSecondaryAction>
                  <VideoPopup videoURL={HELP_VIDEOS.GAME_MENU_ORGANISERS} />
                </ListItemSecondaryAction>
              </ListItem>
              {!shouldPayBeforePlay && (
                <>
                  <ListItem
                    button
                    className={classes.menuListItemWithAction}
                    onClick={() =>
                      showAuxiliaryDialog(
                        <LinkedGamesList game={game} />,
                        "lg",
                        true,
                        true,
                        true,
                        `Linked Games with ${game.name}`,
                      )
                    }
                  >
                    <IconButton>
                      <Link color="primary" />
                    </IconButton>
                    <ListItemText className={"fullWidth"}>Linked Games</ListItemText>
                    <ListItemSecondaryAction>
                      <VideoPopup />
                    </ListItemSecondaryAction>
                  </ListItem>

                  {(imOrganiser || isAdmin) && (
                    <ListItem
                      button
                      className={classes.menuListItemWithAction}
                      onClick={() => {
                        this.setState({ emailOpen: true });
                      }}
                    >
                      <IconButton className={classes.qsLabel}>
                        <Email color={"primary"} />
                      </IconButton>
                      <ListItemText>Email Players</ListItemText>
                      <ListItemSecondaryAction>
                        <VideoPopup videoURL={HELP_VIDEOS.GAME_MENU_EMAIL} />
                      </ListItemSecondaryAction>
                    </ListItem>
                  )}
                </>
              )}
            </>
          )}
          {(imOrganiser || isAdmin) && game.state === GState.WaitingList && (
            <ListItem button onClick={() => this.props.activateGame(game._id)}>
              <IconButton>
                <PlayCircleFilled color={"secondary"} />
              </IconButton>
              <ListItemText className={"fullWidth"}>Activate the Game</ListItemText>
            </ListItem>
          )}
          {imPlaying && game.state !== GState.Done && (
            <ListItem button onClick={() => this.onLeaveGame(game._id)}>
              <IconButton>
                <ExitToApp color={"primary"} />
              </IconButton>
              <ListItemText className={"fullWidth"}>Leave the Game</ListItemText>
            </ListItem>
          )}
          {!imPlaying && game.state !== GState.Done && (
            <ListItem button onClick={() => this.onJoinGame(game._id)}>
              <IconButton className={classes.qsLabel}>Join</IconButton>
              {!isGameFull ? (
                <ListItemText className={"fullWidth"}>Join the Game</ListItemText>
              ) : (
                <label className={classes.errorLabel}>GAME FULL</label>
              )}
            </ListItem>
          )}
          <ListItem
            button
            onClick={() =>
              showDialog(
                <article
                  style={{
                    fontWeight: "normal",
                    padding: "0 1rem",
                    fontFamily: "Arial, sans-serif",
                  }}
                  dangerouslySetInnerHTML={{ __html: game.course?.localRules || "" }}
                />,
                "md",
                false,
                true,
                true,
                "",
                `${game.course?.club.logo ? Config.API_URL + game.course.club.logo : ""}`,
              )
            }
          >
            <IconButton className={classes.qsLabel}>
              <Gavel color={"primary"} />
            </IconButton>
            <ListItemText>Local Rules</ListItemText>
          </ListItem>
          {!shouldPayBeforePlay && (
            <>
              {game.leaderboard?.activateStatus === config.LEADERBOARD_CONFIG.ACTIVATED.ORGANIZER_ONLY &&
              !imOrganiser ? null : (
                <ListItem
                  button
                  className={classes.menuListItemWithAction}
                  onClick={() => this.onOpenLarboard(game._id, game.leaderboard?.widescreen)}
                >
                  <IconButton className={classes.qsLabel}>
                    <Assignment color={"primary"} />
                  </IconButton>
                  <ListItemText>Leaderboard</ListItemText>
                  <ListItemSecondaryAction>
                    <VideoPopup videoURL={HELP_VIDEOS.GAME_MENU_LEADERBOARD} />
                  </ListItemSecondaryAction>
                </ListItem>
              )}

              {game.state !== GState.Done && (
                <>
                  <ListItem
                    button
                    className={classes.menuListItemWithAction}
                    onClick={() => {
                      showAuxiliaryDialog(
                        <QRCode url={`http://schala.golf/join/${game.code}`} game={game} />,
                        "lg",
                        true,
                        true,
                        true,
                      );
                    }}
                  >
                    <IconButton>
                      <CropFreeIcon color="primary" />
                    </IconButton>
                    <ListItemText>Generate QR code</ListItemText>
                    <ListItemSecondaryAction>
                      <VideoPopup videoURL={HELP_VIDEOS.GAME_MENU_QR} />
                    </ListItemSecondaryAction>
                  </ListItem>

                  <ListItem
                    button
                    className={classes.menuListItemWithAction}
                    onClick={() =>
                      share({
                        title: Messages.share.title,
                        text: Messages.share.message,
                        url: `http://schala.golf/join/${game.code}`,
                      })
                    }
                  >
                    <IconButton>
                      <Share color={"primary"} />
                    </IconButton>
                    <ListItemText>Share this game</ListItemText>
                    <ListItemSecondaryAction>
                      <VideoPopup videoURL={HELP_VIDEOS.GAME_MENU_SHARE} />
                    </ListItemSecondaryAction>
                  </ListItem>
                </>
              )}
            </>
          )}
          {imPlaying && isRangeGame(game) && (
            <ListItem button className={classes.menuListItemWithAction} onClick={this.onOpenRhiCalculationTable}>
              <IconButton className={classes.qsLabel}>
                <Assessment color="primary" />
              </IconButton>
              <ListItemText className="fullWidth">RHI Calculation Table</ListItemText>
            </ListItem>
          )}
          {imPlaying && !isRangeGame(game) && (
            <ListItem
              className={classes.menuListItemWithAction}
              style={{ backgroundColor: "orange", padding: "0 8px" }}
            >
              <Button
                disabled={
                  shouldPayBeforePlay ||
                  !_.isEmpty(player.submitionEmail) ||
                  game.state === GState.Done ||
                  (player.holes[1] && !!player.holes[1].gross)
                }
                color={"primary"}
                variant={"contained"}
                style={{ width: 170 }}
                onClick={this.sendNotifierMail}
              >
                {_.isEmpty(player.submitionEmail) ? "CARD FOR HANDICAP" : "Sent"}
              </Button>
              <ListItemText className={"fullWidth"} style={{ padding: 8 }}>
                {shouldPayBeforePlay ? (
                  <span>
                    Pay your entry fee using <strong>Payment</strong> above before you can play.
                  </span>
                ) : (
                  <small>Notify this club and home club that you wish to submit this card for handicap purposes.</small>
                )}
              </ListItemText>
              <ListItemSecondaryAction style={{ top: "70%" }}>
                <VideoPopup videoURL={HELP_VIDEOS.GAME_MENU_CARD} />
              </ListItemSecondaryAction>
            </ListItem>
          )}
        </List>
        <EmailDialog />

        <EmailOptionsDialog
          options={[EmailTypes.START_SHEET, EmailTypes.EMPTY]}
          game={game}
          user={this.props.user}
          gamesObj={this.props.games}
          open={this.state.emailOpen}
          onClose={() => {
            this.setState({ emailOpen: false });
          }}
        />
      </div>
    );
  }
}

const styles = (theme: Theme) =>
  createStyles({
    menuRoot: {
      width: "100%",
      maxWidth: "100%",
      boxSizing: "border-box",
      [`@media (max-width: ${MOBILE_BREAKPOINT}px)`]: {
        overflowX: "hidden",
      },
    },
    menuList: {
      width: "100%",
      maxWidth: "100%",
      boxSizing: "border-box",
      [`@media (max-width: ${MOBILE_BREAKPOINT}px)`]: {
        overflowX: "hidden",
      },
      "& .MuiListItemText-root": {
        minWidth: 0,
        marginRight: 0,
      },
      "& .MuiListItemText-root .MuiTypography-root": {
        overflowWrap: "anywhere",
      },
    },
    menuListItemWithAction: {
      [`@media (max-width: ${MOBILE_BREAKPOINT}px)`]: {
        paddingRight: theme.spacing(7),
        boxSizing: "border-box",
        maxWidth: "100%",
        "& .MuiListItemSecondaryAction-root": {
          right: theme.spacing(1),
        },
      },
    },
    paymentLabelRow: {
      minWidth: 0,
      rowGap: theme.spacing(0.5),
    },
    qsLabel: {
      color: theme.palette.primary.main,
      fontSize: 16,
    },
    errorLabel: {
      color: "red",
    },
    paymentRequiredRow: {
      backgroundColor: "rgba(211, 47, 47, 0.06)",
    },
    paymentRequiredIcon: {
      color: "#d32f2f",
      fontSize: 16,
      fontWeight: 700,
    },
    paymentStatusChip: {
      height: 22,
      marginLeft: theme.spacing(1),
      fontSize: "0.6875rem",
      fontWeight: 600,
      letterSpacing: "0.02em",
      "& .MuiChip-label": {
        paddingLeft: theme.spacing(0.5),
        paddingRight: theme.spacing(1),
      },
      "& .MuiChip-icon": {
        marginLeft: theme.spacing(0.75),
        marginRight: -2,
      },
    },
    paymentStatusChipNoIcon: {
      height: 22,
      marginLeft: theme.spacing(1),
      fontSize: "0.6875rem",
      fontWeight: 600,
      letterSpacing: "0.02em",
      "& .MuiChip-label": {
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
      },
    },
    paymentConfirmedChip: {
      backgroundColor: "rgba(46, 125, 50, 0.12)",
      color: "#2e7d32",
    },
    paymentConfirmedChipIcon: {
      color: "#2e7d32",
      fontSize: "0.75rem",
      width: "0.75rem",
      height: "0.75rem",
      marginLeft: theme.spacing(0.5),
    },
    paymentRequiredChip: {
      backgroundColor: "#f6e7e7",
      color: "#d20000",
    },
    paymentRequiredChipIcon: {
      color: "#d20000",
      fontSize: "0.875rem",
      width: "0.875rem",
      height: "0.875rem",
      marginLeft: theme.spacing(0.5),
      marginRight: -1,
    },
    paymentAllSettledChip: {
      backgroundColor: theme.palette.grey[200],
      color: theme.palette.text.secondary,
    },
    paymentGuestChip: {
      backgroundColor: theme.palette.grey[200],
      color: theme.palette.text.secondary,
    },
  });

const mapStateToProps = (state: GlobalState) => {
  const { joinedGames, organisedByMe } = state.games;
  const { loading } = state.general;
  const { user } = state.auth;
  return {
    user,
    loading,
    games: { ...organisedByMe, ...joinedGames },
  };
};

export default connect(mapStateToProps, {
  getGameById: GameActions.getById,
  recalculatePlayingHcp: GameActions.recalculatePlayingHcp,
  updateMe: UserAction.updateMe,
  updateHcp: UserAction.updateHcp,
  leaveGame: GameActions.leaveGame,
  joinGame: GameActions.joinGame,
  activateGame: GameActions.activateGame,
  switchComponent,
})(withStyles(styles)(GameNavigationDialog));
